import { Pipe, PipeTransform } from '@angular/core';
import { Helper } from '@core/util/helper';
import { EnumConstants } from 'app/shared/enum/enum.constants';

@Pipe({
  name: 'nameFormat',
})
export class NameFormatPipe implements PipeTransform {
  transform(nameFormat: string, title: string, firstName: string, lastName: string, churchMemberId?: string): any {
    const tempTitle = title ? Helper.toTitleCase(title) + '.' : '';
    const tempFirstName = firstName && firstName !== '.' && firstName !== '-' ? ' ' + Helper.toTitleCase(firstName) : '';
    const tempLastName = lastName && lastName !== '.' && lastName !== '-' ? ' ' + Helper.toTitleCase(lastName) : '';
    const tempChurchMemberId = churchMemberId ? ' (' + churchMemberId.toUpperCase() + ')' : '';

    let formattedName = '';
    if (nameFormat === EnumConstants.nameFormat.firstNameLastName) {
      formattedName = `${tempTitle}${tempFirstName}${tempLastName}${tempChurchMemberId}`;
    } else if (nameFormat === EnumConstants.nameFormat.firstNameDotLastName) {
      formattedName = `${tempTitle}${tempFirstName}${tempLastName !== '' ? (tempFirstName !== '' ? '.' + tempLastName : tempLastName) : ''}${tempChurchMemberId}`;
    } else if (nameFormat === EnumConstants.nameFormat.firstNameCapsDotLastName) {
      formattedName = `${tempTitle}${tempFirstName.toUpperCase()}${tempLastName !== '' ? (tempFirstName !== '' ? '.' + tempLastName : tempLastName) : ''}${tempChurchMemberId}`;
    } else if (nameFormat === EnumConstants.nameFormat.lastNameFirstName) {
      formattedName = `${tempTitle}${tempLastName}${tempFirstName}${tempChurchMemberId}`;
    } else if (nameFormat === EnumConstants.nameFormat.lastNameDotFirstName) {
      formattedName = `${tempTitle}${tempLastName}${tempFirstName !== '' ? (tempLastName !== '' ? '.' + tempFirstName : tempFirstName) : ''}${tempChurchMemberId}`;
    } else if (nameFormat === EnumConstants.nameFormat.lastNameCapsDotFirstName) {
      formattedName = `${tempTitle}${tempLastName.toUpperCase()}${tempFirstName !== '' ? (tempLastName !== '' ? '.' + tempFirstName : tempFirstName) : ''}${tempChurchMemberId}`;
    }

    formattedName = formattedName.replace(/\s+/g, ' ').trim().replace(/\.$/, '');
    return formattedName;
  }
}
